import { createFileRoute } from "@tanstack/react-router";

import { ConnectionsSettingsPanel } from "../components/settings/ConnectionsSettings";
import { EnvironmentPage } from "../components/settings/EnvironmentPage";

function SettingsConnectionsRoute() {
  const { environment } = Route.useSearch();
  return environment ? (
    // Keyed so one machine's page never carries state into another's.
    <EnvironmentPage key={environment} address={environment} />
  ) : (
    <ConnectionsSettingsPanel />
  );
}

export const Route = createFileRoute("/settings/connections")({
  // `environment` opens one Environment's page; without it the list shows.
  validateSearch: (raw: Record<string, unknown>): { environment?: string } =>
    typeof raw.environment === "string" && raw.environment.trim()
      ? { environment: raw.environment }
      : {},
  component: SettingsConnectionsRoute,
});
